import React from "react";
import Validate from 'validate.js';
import {connect} from "react-redux";
import l10n from "../../l10n/localization";
import validation from '../../validation/cargoPort';
import Loader from "../common/Loader";
import DateTimePicker from "../forms/fields/DateTimePicker";
import SelectPorts from "../forms/fields/SelectPorts";
import * as portActions from "../../actions/port";
import * as cargoUtils from "../../utils/cargo";
import * as cargoActions from "../../actions/cargoPort";
import Checkbox from "../forms/fields/Checkbox";
import CWForm from "../forms/CWForm";

class LoadingPort extends React.Component {
    DISCHARGING = 'DISCHARGING';
    LOADING = 'LOADING';

    constructor(props) {
        super(props);

        let item = cargoUtils.cargoToForm(this.props.cargoes.getById(this.props.item.item.id));
        this.obj = {
            item: item,
            loadingPort: item.loadingPort !== undefined ?  item.loadingPort : null,
            dischargingPort: item.dischargingPort !== undefined ?  item.dischargingPort : null,
        };

        this.state = {
            isLoadingDirty: false,
            isDischargingDirty: false,
            loadingPort: item.loadingPort !== undefined ?  item.loadingPort : null,
            dischargingPort: item.dischargingPort !== undefined ? item.dischargingPort : null,
            uiSchema: {
                id: {"ui:widget": "hidden"},
                estimatedTimeOfArrival: {
                    "ui:field": "dateTimePicker",
                    "ui:emptyValue": null,
                },
                port: {
                    "ui:field": "selectPort",
                },
                operation: {"ui:widget": "hidden"},
                cargo: {"ui:widget": "hidden"},
                isConfirmed: {"ui:field": "checkbox"}
            },
            fields: {
                dateTimePicker: DateTimePicker,
                selectPort: SelectPorts,
                checkbox: Checkbox,
            }
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.item.item !== nextProps.item.item) {
            let item = cargoUtils.cargoToForm(nextProps.cargoes.getById(nextProps.item.item.id));
            this.obj = {
                item: item,
                loadingPort: item.loadingPort !== undefined ?  item.loadingPort : null,
                dischargingPort: item.dischargingPort !== undefined ?  item.dischargingPort : null,
            };
        }
    }

    componentDidMount() {
        this.props.dispatch(portActions.fetchPorts(true));
    }

    handleChangeLoading = (formData) => {
        let nextState = this.state;

        if(!this.state.isLoadingDirty) {
            nextState.isLoadingDirty = true;
        }
        nextState.loadingPort = formData.formData;
        this.setState((state) => {return {...state, nextState}});
    };

    handleChangeDischarging = (formData) => {
        let nextState = this.state;

        if(!this.state.isDischargingDirty) {
            nextState.isDischargingDirty = true;
        }
        nextState.dischargingPort = formData.formData;
        this.setState((state) => {return {...state, nextState}});
    };

    getSchema(type) {
        return {
            type: "object",
            title: type === this.LOADING ? l10n.port.load : l10n.port.discharge,
            properties: {
                id: {
                    type: "string"
                },
                estimatedTimeOfArrival: {
                    type: "integer",
                    title: type === this.LOADING ? l10n.port.etd : l10n.port.eta,
                },
                operation: {
                    type: "string",
                },
                port: {
                    type: "string",
                    title: l10n.port.port,
                    openDrawer: this.props.openDrawer,
                },
                cargo: {
                    type: "string",
                },
                isConfirmed: {
                    type: "boolean",
                    title: l10n.port.isConfirmed,
                    locked: this.props.saving
                }
            }
        };
    }

    onSubmitLoading({formData}) {
        let form = Object.assign({}, {...formData});

        form.cargo = this.obj.item.id;
        if (form.operation === undefined) form.operation = 'LOAD';
        if (form.isConfirmed === undefined) form.isConfirmed = false;

        if (this.obj.item !== undefined) {
            if (form.id === undefined && this.obj.item !== undefined) {
                let newItem = {...this.obj.item, loadingPort: formData};
                this.obj = {...this.obj, loadingPort: formData, item: newItem};
                this.props.dispatch(cargoActions.add(form, this.props.item.fog.id));
            } else {
                let newItem = {...this.obj.item, loadingPort: formData};
                this.obj = {...this.obj, loadingPort: formData, item: newItem};
                this.props.dispatch(cargoActions.edit(form, this.props.item.fog.id));
            }
        }
        this.setState((state) => {return {...state, isLoadingDirty: false, loadingPort: formData};});
    }

    onSubmitDischarging({formData}) {
        let form = Object.assign({}, {...formData});

        form.cargo = this.obj.item.id;
        if (form.operation === undefined) form.operation = 'DISCHARGE';
        if (form.isConfirmed === undefined) form.isConfirmed = false;

        if (this.obj.item !== undefined) {
            if (form.id === undefined && this.obj.item !== undefined) {
                let newItem = {...this.obj.item, dischargingPort: formData};
                this.obj = {...this.obj, dischargingPort: formData, item: newItem};
                this.props.dispatch(cargoActions.add(form, this.props.item.fog.id));
            } else {
                let newItem = {...this.obj.item, dischargingPort: formData};
                this.obj = {...this.obj, dischargingPort: formData, item: newItem};
                this.props.dispatch(cargoActions.edit(form, this.props.item.fog.id));
            }
        }
        this.setState((state) => {return {...state, isDischargingDirty: false, dischargingPort: formData};});
    }

    validate = (formData, errors) => {
        let validationErrors = Validate(formData, validation, {fullMessages: false});

        if (validationErrors !== undefined) {
            for (let key in validationErrors) {
                if (validationErrors.hasOwnProperty(key)) {
                    if (errors[key] !== undefined) {
                        for (let i = 0; i < validationErrors[key].length; i++) {
                            errors[key].addError(validationErrors[key][i]);
                        }
                    }
                }
            }
        }
        return errors;
    };

    render() {
        let formLoadingClassName = (this.state.isLoadingDirty) ? 'loading-port dirty':'loading-port';
        let formDischargingClassName = (this.state.isDischargingDirty) ? 'loading-port dirty':'loading-port';

        if (this.props.loading || this.obj.item === null) {
            return (<div><Loader /></div>)
        }

        return (
            <div>
                <span className={formLoadingClassName}>
                    <CWForm
                        schema={this.getSchema(this.LOADING)}
                        uiSchema={this.state.uiSchema}
                        showErrorList={false}
                        validate={this.validate.bind(this)}
                        onSubmit={this.onSubmitLoading.bind(this)}
                        fields={this.state.fields}
                        liveValidate={true}
                        onChange={({formData})=> {this.handleChangeLoading({formData})}}
                        formData={this.state.loadingPort} >
                        <div>
                            <button type="submit" className="btn btn-info validate" disabled={this.props.saving}>{l10n.common.save}</button>
                        </div>
                    </CWForm>
                </span>
                <span className={formDischargingClassName}>
                    <CWForm
                        schema={this.getSchema(this.DISCHARGING)}
                        uiSchema={this.state.uiSchema}
                        showErrorList={false}
                        validate={this.validate.bind(this)}
                        onSubmit={this.onSubmitDischarging.bind(this)}
                        fields={this.state.fields}
                        liveValidate={true}
                        onChange={({formData})=> {this.handleChangeDischarging({formData})}}
                        formData={this.state.dischargingPort} >
                        <div>
                            <button type="submit" className="btn btn-info validate" disabled={this.props.saving}>{l10n.common.save}</button>
                        </div>
                    </CWForm>
                </span>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        cargoes: state.cargo.cargoes,
        loading: state.cargoPort.loading,
        saving: state.cargoPort.saving,

        cargoSaving: state.cargo.saving,
        cargoLoading: state.cargo.loading,
    });
})(LoadingPort);


// WEBPACK FOOTER //
// ./src/components/cargo/LoadingPort.js